<template>
  <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%">
    <el-table-column
            fixed
            type="index"
            label="序号"
            :index="indexMethod"
            width="100">
    </el-table-column>
    <el-table-column
            fixed
            prop="guesserContent"
            label="竞猜者的答案"
            width="180">
    </el-table-column>
    <el-table-column
            prop="guesserName"
            label="竞猜者的姓名"
            width="180">
    </el-table-column>
    <el-table-column
            prop="guesserPhone"
            label="竞猜者的电话"
            width="180">
    </el-table-column>
    <el-table-column
            prop="guesserAddress"
            label="竞猜者的地址"
            width="180">
    </el-table-column>
    <el-table-column
            prop="commitTime"
            label="提交时间"
            width="180">
    </el-table-column>
    <el-table-column
            prop="isAwards"
            label="是否获奖"
            width="180">
    </el-table-column>
    <el-table-column
            fixed="right"
            label="操作"
            width="150">
      <template slot-scope="scope">
        <el-button type="text" size="small" @click="view(scope.row.id)">选为中奖</el-button>
        <el-button type="text" size="small" @click="update(scope.row.id)">取消中奖</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  import {getGuessList,isAwardsTrue,isAwardsFalse} from "../../network/guess";

  export default {
    name: "marketingMerchantsTable",
    props: {
      tableData: Array
    },
    data() {
      return {
      }
    },
    methods: {
      indexMethod(index) {
        return index+1;
      },
      view(id){
        //选为中奖
        isAwardsTrue(id).then(res => {
          this.$emit("view",id)
        })
      },
      update(id){
        //取消中奖
        isAwardsFalse(id).then(res => {
          this.$emit("update",id)
        })
      }
    },
  }
</script>

<style scoped>
  .red{
    color: red;
  }
</style>
